$loader-blue: #1279cb;
$loader-bg-overlay: rgb(1 1 1 / 60%);

body.sn-popup-form-loader-open {
  overflow: hidden;
}

.sn-popup-form-loader {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background: $loader-bg-overlay;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: -1;

  &--visible {
    opacity: 1;
    visibility: visible;
    z-index: 1001;

    .sn-popup-form-loader__progress-fill--active {
      animation: sn-loader-progress 10s linear both;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: map-get($spacings, 2xl) map-get($spacings, 2xl) map-get($spacings, 3xl);
    width: 100%;
    height: 100%;
    background: $color-neutral-white;

    @include desktop {
      max-width: 590px;
      max-height: 420px;
      border-radius: map-get($border-radii, md);
      box-shadow: 0 10px 20px rgb(0 0 0 / 50%);
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: map-get($spacings, 3xl);

    svg {
      width: 176px;
      height: 95px;
    }
  }

  &__progress-bar {
    width: 190px;
    height: 4px;
    background: $color-neutral-neutral-lightest;
    border-radius: 4px;
    overflow: hidden;
  }

  &__progress-fill {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background: $loader-blue;
    transform: translateX(-100%);

    &--active {
      /* animation applied via --visible parent */
    }
  }

  &__phrases {
    position: relative;
    width: 100%;
    height: 24px;
    margin-top: map-get($spacings, md);
    text-align: center;
    overflow: hidden;
  }

  &__phrase {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    font-size: map-get($font-sizes, sm);
    line-height: 24px;
    color: $color-neutral-neutral-darker;
    background: $color-neutral-white;
    transform: translateY(100%);
    transition: transform 0.3s ease;

    &--active {
      transform: translateY(0);
    }
  }
}

@keyframes sn-loader-progress {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(0%);
  }
}
